import React from 'react'

import './UnderHeader.scss'

export default function UnderHeader({ className }) {
  return (
    <div className={`underHeader ${className}`}>
    </div>
  )
}
